import request from '@/services/interceptor.js'

export const get_configurazione = (modulo = 'serramenti') => {
    return request({ url: `/config/campi/${modulo}`, method: 'get', loadingBar: false })
}

/**
 * @param {string}      modulo
 * @param {number|null} aziendaId  null = globali, number = azienda specifica
 */
export const get_configurazione_admin = (modulo = 'serramenti', aziendaId = null) => {
    return request({
        url: `/config/campi/${modulo}/admin`,
        method: 'get',
        params: aziendaId != null ? { aziendaId } : {},
        loadingBar: true
    })
}

export const update_configurazione_batch = (modulo = 'serramenti', campi = [], aziendaId = null) => {
    return request({
        url: `/config/campi/${modulo}/admin`,
        method: 'put',
        data: { modulo, campi },
        params: aziendaId != null ? { aziendaId } : {},
        loadingBar: true
    })
}

export const crea_richiesta = (data) => {
    return request({
        url: '/config/campi/richieste',
        method: 'post',
        data,
        loadingBar: true
    })
}

export const get_richieste_mie = () => {
    return request({
        url: '/config/campi/richieste/mie',
        method: 'get',
        loadingBar: true
    })
}

export const get_richieste_admin = (stato = null) => {
    return request({
        url: '/config/campi/richieste',
        method: 'get',
        params: stato ? { stato } : {},
        loadingBar: true
    })
}

export const aggiorna_richiesta = (id, data) => {
    return request({
        url: `/config/campi/richieste/${id}`,
        method: 'put',
        data,
        loadingBar: true
    })
}